import { EntityId } from "@jackfruit/common"
import { ActionCreatorWithPayload, PayloadAction } from "@reduxjs/toolkit"
import { couponCodeStatus } from "~/interfaces/entities/Cart"
import { VNZSessionImage } from "~/interfaces/entities/VNZSessionImage"
import { createEntitySlice } from "../createEntitySlice"
import { EnhancedEntityState } from "../store"

export interface VNZSessionImagesState extends EnhancedEntityState<VNZSessionImage> {
  hasSessionData: boolean
  isProcessing: boolean
  hasBeenProcessed: boolean
  printProduct?: EntityId
  promoCodes?: string[]
  pendingCouponStatus: couponCodeStatus
}

interface VNZSessionImagesActions {
  setHasSessionData: ActionCreatorWithPayload<boolean>
  setIsProcessing: ActionCreatorWithPayload<boolean>
  setHasBeenProcessed: ActionCreatorWithPayload<boolean>
  processVNZSessionImages: ActionCreatorWithPayload<void>
  setHasError: ActionCreatorWithPayload<boolean>
  setPrintProduct: ActionCreatorWithPayload<number | string>
  setPromoCodes: ActionCreatorWithPayload<string[]>
  setPendingCouponStatus: ActionCreatorWithPayload<couponCodeStatus>
}

const { slice, selectors: vnzSessionImagesSelectors } =
  createEntitySlice<VNZSessionImage>(
    "VNZSessionImages",
    {},
    {
      hasSessionData: false,
      isProcessing: false,
      hasBeenProcessed: false,
      printProduct: undefined,
      promoCodes: [],
    },
    {
      setHasSessionData(state, action: PayloadAction<boolean>) {
        state.hasSessionData = action.payload
      },
      setIsProcessing(state, action: PayloadAction<boolean>) {
        state.isProcessing = action.payload
      },
      setHasBeenProcessed(state, action: PayloadAction<boolean>) {
        state.hasBeenProcessed = action.payload
      },
      setPrintProduct(state, action: PayloadAction<number | string>) {
        state.printProduct = action.payload
      },
      setPromoCodes(state, action: PayloadAction<string[]>) {
        state.promoCodes = action.payload
      },
      processVNZSessionImages(state) {},
      setPendingCouponStatus(state, action: PayloadAction<couponCodeStatus>) {
        state.pendingCouponStatus = action.payload
      },
    },
  )

const vnzSessionImages = {
  ...slice,
  actions: slice.actions as typeof slice.actions & VNZSessionImagesActions,
}

export { vnzSessionImages, vnzSessionImagesSelectors }
